import { call, put } from 'redux-saga/effects';
import { BACKEND_URL } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { loadStatCameraFailed, loadStatCameraSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';

export default function* loadStatCamera(action) {
  try {
    const url = `${BACKEND_URL}/host-statuses/total`;
    const pool = { filter: { type: 2 } };
    const userDataResponse = yield makeRequest(url, pool, action, 'POST');
    const responseJson = yield userDataResponse.json();
    if (userDataResponse && userDataResponse.status === OK && responseJson.result) {
      yield put(loadStatCameraSuccessful(responseJson.result));
      yield call(resolveActionPromise(action, responseJson));
    } else {
      yield put(loadStatCameraFailed(responseJson));
      yield call(rejectActionPromise(action, responseJson));
    }
  } catch (e) {
    yield put(loadStatCameraFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
